import type { InsulinAverageBolusInsight } from "@tandemdiabetes/sugarmate-api-react-client"
import { useCalculationsContext } from "../CalculationsContext"
import type { TileProps } from "./TileProps"
import { TileTimeSpan } from "./TileTimeSpan"
import { TileTitle } from "./TileTitle"
import { TileUnit } from "./TileUnit"
import { TileValue } from "./TileValue"
import { usePolyglot } from "src/contexts"
import { round } from "src/utils"

export function InsulinAverageBolus(props: TileProps<InsulinAverageBolusInsight>) {
  const {
    insightKey,
    range,
  } = props

  const polyglot = usePolyglot()
  const days = range / 24

  const { insulinCalculations } = useCalculationsContext()
  const { totalBolusUnits } = insulinCalculations[range] || {}

  const value = totalBolusUnits === undefined ?
    NaN :
    round(
      totalBolusUnits / days,
      3,
    )

  const unit = polyglot.t(
    "unit.units_day",
    isNaN(value) ? 0 : value,
  )

  return (
    <>
      <TileTitle insightKey={insightKey} />
      <TileTimeSpan
        id={`${insightKey}-time-range`}
        range={range}
      />
      <TileValue id={`${insightKey}-value`}>
        {isNaN(value) ? "--" : value.toLocaleString(polyglot.locale())}
      </TileValue>
      <TileUnit id={`${insightKey}-unit`}>
        {unit}
      </TileUnit>
    </>
  )
}
